









import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class VRangeSliderZoom extends Vue {
  @Prop({ default: 0, type: [String, Number] }) min!: number;
  @Prop({ default: 100, type: [String, Number] }) max!: number;
  @Prop({ default: 1, type: [String, Number] }) step!: number;
  @Prop({ default: 0, type: [String, Number] }) value!: number;

  input(e: Event) {
    if (!e.target) return;
    this.$emit("input", (e.target as HTMLInputElement).valueAsNumber);
  }

  change(e: Event) {
    if (!e.target) return;
    // IE対応のためinputも投げる
    this.$emit("input", (e.target as HTMLInputElement).valueAsNumber);
    this.$emit("change", (e.target as HTMLInputElement).valueAsNumber);
  }
}
